var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{staticClass:"form-control",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"config":_vm.mergedConfig,"tabindex":_vm.tabindex,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }